import { Editor } from "@monaco-editor/react";
import { ReactElement } from "react";

type MonacoLiquidEditorProps = {
  bordered?: boolean;
  className?: string;
  onChange(value: string): void;
  value: string;
  width: string;
};

const MonacoLiquidEditor = ({
  bordered = true,
  className,
  onChange,
  value,
  width,
}: MonacoLiquidEditorProps): ReactElement => {
  return (
    <Editor
      className={`${bordered ? "monaco-bordered" : ""} ${className}`}
      height="100%"
      language="liquid"
      onChange={(value) => onChange(value || "")}
      options={{
        automaticLayout: true,
        glyphMargin: false,
        lineNumbers: "off",
        lineNumbersMinChars: 2,
        links: false,
        minimap: { enabled: false },
        padding: { bottom: 4, top: 4 },
        scrollbar: {
          horizontal: "hidden",
          vertical: "auto",
        },
        wordWrap: "off",
      }}
      theme="miru-dark"
      value={value}
      width={width}
    />
  );
};

export default MonacoLiquidEditor;
